<template>
    <Paper class="paper">
        <h2 class="headline  py-3 px-4 m-0">
            {{ header }}
        </h2>
        <Divider />
        <div class="p-4">
            <h6 class="mb-3">{{ fileName }}</h6>
            <div class="alert alert-warning">{{ $t('documents.cv.consent') }}</div>
            <div class="d-flex flex-row-reverse mt-3 w-100">
                <div class="d-flex flex-row-reverse mt-3">
                    <BaseButton variant="secondary" @click="onOk">{{
                        $t('general.ok')
                    }}</BaseButton>
                    <BaseButton variant="text-secondary" @click="onClose">{{
                        $t('general.cancel')
                    }}</BaseButton>
                </div>
            </div>
        </div>
    </Paper>
</template>

<script>
import CandidateService from '~/services/CandidateServiceOld';

export default {
    name: 'UploadCVDialog',
    props: {
        file: {
            type: File,
            default: () => {},
        },
        cv: {
            type: Object,
            default: () => {},
        },
    },
    data: () => ({}),
    computed: {
        mode() {
            if (this.file) {
                return 'upload';
            } else {
                return 'edit';
            }
        },
        header() {
            return this.mode === 'upload'
                ? this.$t('documents.cv.documentUpload')
                : this.$t('documents.cv.editDocument');
        },
        fileName() {
            if (this.file) {
                return this.file.name;
            } else {
                return this.cv.fileName;
            }
        },
    },
    methods: {
        onClose() {
            this.clear();
            this.$emit('close');
            this.$interfaces.dialogModal.getState().resolver.res();
        },
        onOk() {
            if (this.mode === 'upload') {
                CandidateService.uploadCV(this.file).then(() => {
                    this.clear();
                    this.$emit('uploaded');
                    this.$interfaces.dialogModal.getState().resolver.res();
                });
            }
        },
        clear() {},

        isValidInput() {},
    },
    watch: {},
};
</script>

<style scoped>
.paper {
    width: 96%;
    max-width: 600px;
}

@media only screen and (max-width: 600px) {
    .paper {
        width: 100%;
        padding-bottom: 100px;
        border-radius: 0 !important;
    }
}
</style>
